import { NavUrls } from "../../utils/routes";
import { FooterLink } from "./FooterLink";
import { FaFacebook } from "react-icons/fa6";
import { BsTwitterX } from "react-icons/bs";
import { Button } from "./Button";

export default function StaticFooter() {
  return (
    <div className="relative my-3 ">
      <div className="px-[50px] md:py-[50px] w-full bg-[#022782] flex flex-wrap flex-col md:flex-row justify-between ">
        <div className=" flex w-[90%] md:w-[20%]  text-white min-h-[10px] md:min-h-[300px] p-[10px] ml-[20px] mt-[30px] flex-col gap-3 ">
          <img
            src="/img/logo.png"
            width={"150px"}
            alt="logo"
            loading="lazy"
            className=""
          />
          <p className=" pb-[20px] text-[14px] md:text-[16px] mt-[10px]">
            Ready to take your trip? Book your flight with us today.
          </p>
          <div className=" flex flex-col gap-3 "></div>
        </div>

        <div className="flex w-[90%] md:w-[20%]  text-white min-h-[10px] md:min-h-[300px] p-[10px] ml-[20px] mt-[30px] flex-col ">
          <p className="pb-[10px] border-b-2 border-white text-[17px] font-bold">
            USEFUL LINKS
          </p>
          <div className="flex flex-col text-[14px] md:text-[16px] pt-5 ">
            {NavUrls?.map((item) => (
              <FooterLink key={item.id} {...item} />
            ))}
            {/* <Link to={routeObj.terms}>
              <div className="w-fit bg-red-00 pb-2 flex items-center gap-5 text-white">
                <BsChevronRight /> Terms & Conditions
              </div>
            </Link> */}
          </div>
        </div>
        <div className=" flex flex-col w-[97%] md:w-[25%]  text-white min-h-[300px] p-[10px] ml-[20px] md:mt-[30px]">
          <p className="pb-[10px] border-b-2 border-white text-[17px] font-bold">
            GET IN TOUCH
          </p>
          <div className="flex flex-col text-[14px] md:text-[16px] ">
            <div className="mt-[10px] flex gap-1 items-center ">
              <FaFacebook />
              facebook
            </div>
            <div className="mt-[10px] gap-1 flex items-center">
              <BsTwitterX />
              twitter
            </div>
            <div className="flex flex-col my-4 gap-3 ">
              <input
                type="text"
                placeholder="Name"
                className=" px-4 outline-none rounded-sm py-2 w-full "
              />
              <input
                type="text"
                placeholder="Email"
                className=" px-4 outline-none rounded-sm py-2 w-full "
              />
              <Button className=" bg-[#1375C2] py-3 ">Sign me up!</Button>
            </div>
          </div>
        </div>
      </div>
      <p className="bg-black text-center relative bottom-0 right-0 left-0 text-white text-[14px] md:text-[16px] py-3 ">
        &copy;{new Date().getFullYear()}. Flightpadi is part of the GorillaZap
        portfolio.
      </p>
    </div>
  );
}
